const azureHostPattern = /(^|\.)(bing)?ads(-int)?\.microsoft\.com$/i;

export type ODataLocation = Pick<Location, 'hostname' | 'protocol'>;

const isAzureEnv = ({
  hostname,
  protocol,
}: ODataLocation) => protocol.toLowerCase() === 'https:' &&
hostname.toLowerCase() !== 'app1.localhost.ccui.devdev.bingads.microsoft.com' &&
azureHostPattern.test(hostname);

export function getODataPath(location: ODataLocation) {
  return isAzureEnv(location) ? 'Campaign/V2' : 'Advertiser/V2';
}

export function getConfig() {
  return {
    odataPath: getODataPath(window.location),
  };
}
